import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import reactDayPickerStyle from /* preval */ './style';

// outline is an accessability CSS property, that should be used, but is often
// removed by design because it doesn't look nice.

const StyledSpan = styled.span`
  ${reactDayPickerStyle}
  & .DayPicker {
    outline: ${(props) => props.style.outline || 'none'};
    width: 100%;
  }
  & .DayPicker-Day {
    outline: ${(props) => props.style.outline || 'none'};
    border: 0;
    padding: ${(props) => props.style.padding || '0.25rem'};
  }
  & .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside),
  & .DayPicker-Day--disabled {
    background: transparent;
    padding: ${(props) => props.style.padding || '0.25rem'};
  }
  & .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    &:hover {
      background-color: transparent;
    }
  }
  & .DayPicker-Month {
    margin: 0;
  }
`;

const Container = ({ style, ...props }) => <StyledSpan {...props} style={style} />;

Container.defaultProps = {
  style: {},
};

Container.propTypes = {
  ...StyledSpan.propTypes,
  style: PropTypes.shape({
    outline: PropTypes.string,
  }),
};

export default Container;
